import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import SectionLoader from '@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader';
import { RootState } from '@/src/reducers/types';

import Body from './Body/Body';
import Container from './Container/Container';
import Header from './Header/Header';
import SelectAllCheckbox from './Header/SelectAll/SelectAllCheckbox';

import { useGetFiles } from '../../api/getFiles';
import { FileListProvider } from '../../store/file-list.store';
import { useLibrarySearchParamsContext } from '../../store/filters.store';
import { LibraryTagsStoreProvider } from '../../store/libraryTags.store';

type ListProps = {
  projectId: string;
  draggingData: any;
};

export const LibraryList = ({ draggingData }: ListProps) => {
  const files = useSelector((state: RootState) => state.files);
  const folderId = files.activeFolder?.id;
  const { filter } = useLibrarySearchParamsContext();
  const filesQuery = useGetFiles({
    folderId,
    filter,
    config: {
      enabled: !!folderId,
    },
  });
  const flatFiles = filesQuery.data?.pages.flatMap((page) => page.data) || [];

  const selectedItems = files.selectedItems;
  const filesWithSelection =
    flatFiles?.map((item) => ({
      ...item,
      isSelected: selectedItems.map((f) => f.id)?.includes(item.id),
    })) ?? [];

  // if (folderId && filesQuery.isLoading) {
  //   return (
  //     <Container>
  //       <Header />
  //       <SectionLoader />
  //     </Container>
  //   );
  // }

  return (
    <FileListProvider filesQuery={filesQuery}>
      <LibraryTagsStoreProvider>
        <Container>
          <Header
            SelectAllComponent={
              <SelectAllCheckbox
                flatFiles={flatFiles}
                enableCondition={(files) => Boolean(files.activeFolder?.id) && flatFiles.length > 0}
              />
            }
          />
          {flatFiles?.length > 0 && (!filesQuery.isLoading || filesQuery.isLoading) && (
            <Body list={filesWithSelection} draggingData={draggingData} />
          )}
          {!filesQuery.isLoading && filesQuery.data !== undefined && flatFiles.length === 0 && (
            <p className="noRecordsFound">No records found.</p>
          )}

          {filesQuery.hasNextPage && (
            <div className="loadMoreFiles">
              <a onClick={() => filesQuery.fetchNextPage()}>Load More</a>
            </div>
          )}
        </Container>
      </LibraryTagsStoreProvider>
    </FileListProvider>
  );
};
